export const ENV = "prod"
// console.log(process.env.REACT_APP_ENV, ENV);
export const HOST =

  ENV === "prod" ? "https://axis.pincinsurance.com" : "https://bfsi.staypinc.com";

export const API = "api";
export const APIPREFIX = `${HOST}/${API}/`;

export const s3_bucket_prod_url =
  "http://pinc-prod-public-bucket.s3-ap-south-1.amazonaws.com/";
export const s3_bucket_uat_url =
  "http://pinc-uat-public-bucket.s3-ap-south-1.amazonaws.com/";

export const UAT = "https://www.staypinc.com/";
export const PROD = "https://www.pincinsurance.com/";

export const PJ_URL = ENV === "prod" ? "https://pj.pincinsurance.com" : "https://pj.staypinc.com";

export const SUB_DIRECTORY = "";

// Login Routes
export const LOGIN = `${HOST}${API}login`;
export const FORGOT_PASSWORD = `${HOST}${API}forgot-password`;
export const NEW_PASSWORD = `${HOST}${API}reset-password`;
export const VERIFY_TOKEN = `${HOST}${API}validate-token`;
// Employer and Admin SEND OTP
export const FORGOT_PASSWORD_EMPLOYER_SEND_OTP = `${APIPREFIX}employer/send-otp`;
export const FORGOT_PASSWORD_ADMIN_SEND_OTP = `${APIPREFIX}admin/send-otp`;
// Employer and Admin VERIFY OTP
export const FORGOT_PASSWORD_EMPLOYER_VERIFY_OTP = `${APIPREFIX}employer/verify-otp`;
export const FORGOT_PASSWORD_ADMIN_VERIFY_OTP = `${APIPREFIX}admin/verify-otp`;
// Employer and CHANGE PASSWORD 
export const FORGOT_PASSWORD_EMPLOYER_CHANGE_PSWD = `${APIPREFIX}employer/change-password`;
export const FORGOT_PASSWORD_ADMIN_CHANGE_PSWD = `${APIPREFIX}admin/change-password`;
//EMPLOYER AND ADMIN LOGIN OUT
export const LOGOUT_EMPLOYER = `${APIPREFIX}employer/logout`;
export const LOGOUT_ADMIN = `${APIPREFIX}admin/logout`;
export const LOGOUT_EMPLOYEE = `${APIPREFIX}employee/logout`;

//Dashboard
export const GET_POLICY_DASHBOARD = `${APIPREFIX}getPolicy`;
export const GET_POLICY_INACTIVE = `${APIPREFIX}getPolicy`;
export const DOWNLOAD_POLICY = `${APIPREFIX}download-policy-doc`;
export const NON_HEALTH_CLAIM = `${APIPREFIX}get-non-health-claim`;

//policy Wallet
// export const POLICY_WALLET = `${APIPREFIX}getLeadPolicy`;
// export const ADD_POLICY_WALLET = `${APIPREFIX}add-lead-policy`;
export const POLICY_WALLET_DELETE = `${APIPREFIX}delete-lead-policy`;

//claim
// export const GET_CLAIM = `${APIPREFIX}getClaim`;  
// export const INTIMATE_CLAIM = `${HOST}/corporate/claim-intimate`;
export const DOWNLOAD_CLAIM_DOC = `${APIPREFIX}download-claim-doc`;
export const UPLOAD_CLAIM_DOC = `${APIPREFIX}claim-upload`;

//my profile
export const ALL_CONTACT_PERSON = `${APIPREFIX}all-contact-person`;
export const PROFILE = `${APIPREFIX}all-contact-person`;
export const UPLOAD_PROFILE_IMAGE = `${APIPREFIX}all-contact-person`;
export const PROFILE_EDIT = `${HOST}/corporate/client-update`;
export const KYC_DOCUMENTS = `${APIPREFIX}all-contact-person`;
export const UPLOAD_KYC_DOCUMENTS = `${APIPREFIX}upload-kyc-document`;
export const KYC_DOCUMENTS_DELETE = `${APIPREFIX}delete-kyc-document`;
export const CLIENT_LIST = `${APIPREFIX}client-list`;
export const POLICY_COMPANY_LIST = `${APIPREFIX}policy-client-list`;
export const CLIENT_DETAILS = `${APIPREFIX}client-detail`;
export const KYC_DOCUMENTS_DOWNLOAD = `${APIPREFIX}download-kyc-document`;
export const CHANGE_PASSWORD = `${APIPREFIX}change-password`;

//common API
export const CITY_DROPDOWN = `${APIPREFIX}`;
export const DROPDOWN = `${APIPREFIX}static-data/all`;
export const SUB_NEWSLETTER = `${APIPREFIX}subscribe-newsletter`;

//Appointments API
export const GET_APPOINTMENTS = `${APIPREFIX}appointments`;

//Add feedback
export const ADD_FEEDBACK = `${APIPREFIX}add-feedback`;
export const INFORMATION_CARD = `${APIPREFIX}static-data/information-card`;

//Add feedback
export const ADD_ENQUIRY = `${APIPREFIX}add-enquiry`;

//reviews
export const REVIEWS = `${APIPREFIX}static-data/reviews`;

//notifications
export const LATEST_NOTIFICATION = `${APIPREFIX}notification/latest`;
export const GET_ALL_NOTIFICATION = `${APIPREFIX}notification/all`;
export const MARK_ALL_NOTIFICATION_READ = `${APIPREFIX}notification/read`;
export const NOTIFICATION_DELETE = `${APIPREFIX}notification/delete`;
export const LOGOUT = `${APIPREFIX}logout`;

// policy list
// export const GET_POLICY_LIST = `${APIPREFIX}policy/getmypolicies`; this is OLD API (Mukesh)
export const GET_POLICY_LIST = `${APIPREFIX}admin/policy/list`;   //Rupesh API



// export const GET_POLICY_LIST = `${APIPREFIX}getPolicy`;
// localhost:3001/api/policy/getpolicies
// client verification
export const CLIENT_VERIFICATION_UPDATE = `${APIPREFIX}update-client`;

// new
export const LOGIN_SEND_OTP = `${APIPREFIX}employee/send-otp`;
export const VERIFY_LOGIN_OTP = `${APIPREFIX}employee/verify-otp`;
export const POLICY_WALLET = `${APIPREFIX}opportunity/getmypolicies`;
export const ADD_POLICY_WALLET = `${APIPREFIX}opportunity/add`;
// export const GET_CLAIM = `${APIPREFIX}claim/getmyclaims` //Mukesh;  
export const GET_CLAIM = `${APIPREFIX}employee/claim-list`;
export const REGISTRATION_FORM = `${APIPREFIX}employee/initregister`;
// export const VERIFY_REG_OTP = `${APIPREFIX}employee/verifyregisteration`; MUKESH API
export const VERIFY_REG_OTP = `${APIPREFIX}employee/verify-otp`;
export const EMPLOYER_LOGIN = `${APIPREFIX}employer/login`;
export const ADMIN_LOGIN = `${APIPREFIX}admin/login`;
export const EMP_LIST = `${APIPREFIX}employee/retrieve?size=500&page=1`;
export const EMP_STATUS = `${APIPREFIX}employee/update`;
export const EMP_CHANGE_STATUS = `${APIPREFIX}admin/change-employee-status`;
export const CLAIM_LIST = `${APIPREFIX}`;
export const POLICY_LIST = `${APIPREFIX}admin/policy/list`;
// export const ENDORSMENT_LIST = `${APIPREFIX}policy/retrieveendorsements`; //OLD
export const ENDORSMENT_LIST = `${APIPREFIX}admin/endorsement/list`;
export const EMPLOYER_QUOTE_LIST = `${APIPREFIX}admin/quote/list`
// export const INTIMATE_CLAIM = `${APIPREFIX}claim/create`; // Mukesh
export const INTIMATE_CLAIM = `${APIPREFIX}employee/claim-add` // Rupesh
export const ADD_NEW_VEHICLE = `${APIPREFIX}new-vehicle/add`;
export const VALIDATE_NEW_VEHICLE = `${APIPREFIX}new-vehicle/validate`; //Prince
export const DOCUMENT_UPLOAD_NEW_VEHICLE = `${APIPREFIX}new-vehicle/document`; //Prince
export const QUOTE_LIST = `${APIPREFIX}quote/get-emp-quotations`;
export const GET_OTHER_QUOTE_LIST = `${APIPREFIX}quote/get-emp-other-quotations`; //Rupesh
export const CD_BAL_LIST = `${APIPREFIX}cd-balance/get-summary`;
export const DOWNLOAD_DOCUMENT = `${APIPREFIX}documentupload/getpresignedurl`
export const SUBMIT_QUOTE = `${APIPREFIX}quote/confirm`;
export const UPLOAD_PAYMENT_DETAILS = `${APIPREFIX}quote/neft-upload`
export const UPLOAD_DOC = `${APIPREFIX}documentupload/upload`;
export const QUOTE_CALC_PREMIUM = `${APIPREFIX}quote/v1/get-emp-calculated-premium`;
// export const ZONE_LIST =`${APIPREFIX}city/cities`; Mukesh API
export const ZONE_LIST = `${APIPREFIX}city/list`
// export const UPDATE_POLICY =`${APIPREFIX}policy/update`;  
export const UPDATE_POLICY = `${APIPREFIX}employee/add-rc`;
// export const SUMMARY_RENEWAL_LIST = `${APIPREFIX}policy/getrenewalssummary`; //Mukesh
export const SUMMARY_RENEWAL_LIST = `${APIPREFIX}admin/dashboard/renewal/detail`;

// export const SUMMARY_CD_BAL_LIST = `${APIPREFIX}policy/getsummary2`; //Mukesh
export const SUMMARY_CD_BAL_LIST = `${APIPREFIX}admin/dashboard/quote/detail`;

export const SUMMARY_CLAIM_STATUS_LIST = ``;
export const SUMMARY_QUOTE_STATUS_LIST = ``;

// START : TASK PANNEL

export const TASK_PANEL_CAPITALIZATION_LIST = `${APIPREFIX}policy/capitalization/list`;
export const TASK_PANEL_CD_RECOVERY_LIST = `${APIPREFIX}policy/cd-recovery/list`;
export const UPDATE_CAPITALIZATION = `${APIPREFIX}policy/capitalization/update`; // popup update cap- rupesh
export const UPDATE_CD_RECOVERY = `${APIPREFIX}policy/cd-recovery/update`;  // opup update Cd -Rupesh

// export const ADD_UPDATE_CAP =`${APIPREFIX}policy/bulkupdate`; //------popup update cap- Mukesh
// END TASK PANNEL

export const QUOTE_SAMPLE1 = `${APIPREFIX}quote/sample1`;
export const SHARE_POLICY = `${APIPREFIX}/policy/share`;

// cops login
export const EMPLOYER_LIST = `${APIPREFIX}employer/retrieve`
export const EMPLOYER_ADD = `${APIPREFIX}employer/create`
export const EMPLOYER_UPDATE = `${APIPREFIX}employer/update`
export const DOCUMENT_BULK_UPLOAD = `${APIPREFIX}documentupload/upload`
export const BULK_UPLOAD = `${APIPREFIX}`
export const ZONES_LISTS = `${APIPREFIX}city/zones`;
export const EMPLOYEE_ADD = `${APIPREFIX}employee/addabcd`;
export const POLICY_ADD = `${APIPREFIX}admin/policy`;
export const EMPLOYEE_NAMES_WITH_CITY = `${APIPREFIX}employee/getemployeesshort`;
export const CLAIM_ADD = `${APIPREFIX}`;
export const CLAIM_EDIT = `${APIPREFIX}admin/claim/edit`;
// export const ENDORSEMENT_ADD = `${APIPREFIX}policy/endorsement-add`; MUKESH
export const ENDORSEMENT_ADD = `${APIPREFIX}admin/endorsement/add`
export const ENDORSEMENT_EDIT = `${APIPREFIX}admin/endorsement/edit`;
export const QUOTE_ADD = `${APIPREFIX}admin/quote/add`;
export const QUOTE_EDIT = `${APIPREFIX}admin/quote/edit`;
export const CD_BAL_UPDATE = `${APIPREFIX}admin/cd/edit`;
export const CD_BAL_ADD = `${APIPREFIX}admin/cd/add`;
// send document on mail
export const SHARE_DOC_ON_MAIL = `${APIPREFIX}documentupload/email-document`;
// source enquiry integration 
export const SOURCE_FOR_ENQUIRY = `${APIPREFIX}employee/get-source`;

export const API_GET_INSURER_LIST = `${APIPREFIX}masters/insurer-list`;











